<template lang='pug'>
  .pts-modal-wrapper
    .close-icon
      span.to-click(@click="closeModal") x

    h4.is-size-4.has-text-black.has-text-centered
      strong Locais de trabalho cadastrados
    .all-rows
      .row.is-2(v-for="company of groupedInfos")
        h3.is-size-6.has-text-black.has-text-centered.mb10 {{company.name}}

</template>

<script>
  import moment from 'moment'
  import { groupBy } from '../../utils'

  export default {
    computed: {
      groupedInfos () {
          const { companies } = this.$store.state.accessData.browserRecord
        return companies
      }
    },
    methods: {
      closeModal () {
        this.$modal.hide('companiesModal');
      }
    }
  }
</script>

<style>
  .all-rows {
    grid-template-rows: auto;
  }

  .close-icon {
    position: absolute;
    color: black;
    right: 0;
    padding-right: 2%;
    padding-top: 0.3%;
    top: 0;

  }


</style>
